var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.56 17.182V9.453h1.545v7.729zm5.667 0V9.453h1.546v7.729zm-8.739 3.606v-1.546h19.023v1.546zm14.406-3.606V9.453h1.546v7.729zM2.488 7.392V5.927L12 1.27l9.511 4.656v1.467zm3.654-1.545h11.716L12 3.013z"
  })));
};
export default SvgBank;